import { LogoMark } from '../components/Logo';
import { LogIn } from 'lucide-react';
import { ICON } from '../components/ui';

export function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <div className="enter w-full max-w-sm">
        <div className="flex select-none items-center gap-2.5">
          <LogoMark className="h-7 w-6" />
          <h1>Trigion</h1>
        </div>
        <p className="t-muted mt-2">Je diensten, toeslagen en loon op één plek.</p>

        <div className="card mt-6 space-y-3">
          <a href="/api/auth/google/login" className="btn-primary w-full">
            <LogIn className={ICON.sm} aria-hidden />
            Inloggen met Google
          </a>
          <p className="text-center text-xs text-slate-500">Alleen voor het gekoppelde Google-account.</p>
        </div>
      </div>
    </div>
  );
}
